import { useEffect, useState } from "react";
import { isAppsInTossChannel } from "../api-url";
type InstallEvent = Event & { prompt: () => Promise<void> };
export function InstallPrompt() {
	const [event, setEvent] = useState<InstallEvent | null>(null),
		[hidden, setHidden] = useState(() => {
			try {
				return Number(localStorage.getItem("jgm-install-hidden")) > Date.now();
			} catch {
				return false;
			}
		});
	useEffect(() => {
		const fn = (e: Event) => {
			e.preventDefault();
			setEvent(e as InstallEvent);
		};
		window.addEventListener("beforeinstallprompt", fn);
		return () => window.removeEventListener("beforeinstallprompt", fn);
	}, []);
	if (
		hidden ||
		isAppsInTossChannel() ||
		(typeof window.matchMedia === "function" &&
			window.matchMedia("(display-mode:standalone)").matches)
	)
		return null;
	return (
		<aside className="install-prompt">
			<h3>현지에서 오늘을 바로 열어요.</h3>
			{event ? (
				<button
					type="button"
					className="button secondary"
					onClick={() => void event.prompt()}
				>
					홈 화면에 추가
				</button>
			) : (
				<ol aria-label="아이폰 홈 화면 추가 순서">
					<li>① 사파리 아래의 공유 버튼을 눌러요.</li>
					<li>② 홈 화면에 추가를 골라요.</li>
					<li>③ 추가를 누르면 오늘 바로가기를 쓸 수 있어요.</li>
				</ol>
			)}
			<p>설치 전 여행과 오늘 모드를 한 번 열어 두세요.</p>
			<button
				type="button"
				className="button text"
				onClick={() => {
					try {
						localStorage.setItem(
							"jgm-install-hidden",
							String(Date.now() + 30 * 86400000),
						);
					} catch {}
					setHidden(true);
				}}
			>
				30일 동안 닫기
			</button>
		</aside>
	);
}
